import { API_BASE_URL } from "../config";
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

function ViewAssignedUsersModal({ visible, onClose, projectId }) {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (visible && projectId) {
      fetch(`${API_BASE_URL}/api/admin/projects/${projectId}/users`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => setUsers(data))
        .catch((err) => console.error("Failed to load users:", err));
    }
  }, [visible, projectId]);

  return (
    <Dialog open={visible} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Assigned Users</DialogTitle>
      <DialogContent dividers>
        {users.length > 0 ? (
          <List>
            {users.map((user) => (
              <ListItem key={user.id}>
                <ListItemText primary={user.name} secondary={user.email} />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography>No users assigned to this project.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ViewAssignedUsersModal;
